import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DadosHomeComponent } from './dados-home/dados-home.component';
import { pageAccessGuard } from '../guard/page-access.guard';

const routes: Routes = [
  {
    path: 'home', component: DadosHomeComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'dadosCadastro'
    }
  },
  // { path: 'taxa', component: FormaPagamentoTaxaComponent },
  // { path: 'emissao', component: FormaPagamentoEmissaoComponent },
  // { path: 'cliente', component: FormaPagamentoClienteComponent },
  // { path: 'split', component: FormaPagamentoSplitComponent },
  // { path: 'bancos', component: FormaPagamentoBancosComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DadosRoutingModule { }
